import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AddWorkingType,
  WorkingTypeNameCheck,
  HEADERS,
  getOrgId,
} from "../../api";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

export default function AddWorkingDays() {
  const navigate = useNavigate();
  const OrgID = getOrgId();

  const [validationErrors, setValidationErrors] = useState({
    working_name: "",
    hours_per_day: "",
  });

  const [workingDaysData, setWorkingDaysData] = useState({
    organization_id: OrgID,
    working_name: "",
    hours_per_day: 0,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: false,
    sunday: false,
  });

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const handleAdd = () => {
    const errors = {};
    if (!workingDaysData.working_name) {
      errors.working_name = "Working Name cannot be empty";
    }

    if (!workingDaysData.hours_per_day) {
      errors.hours_per_day = "Hours per day cannot be empty";
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    WorkingNameCheck(workingDaysData.working_name)
      .then((nameAvailable) => {
        if (nameAvailable) {
          const apiData = {
            organization_id: workingDaysData.organization_id,
            working_name: workingDaysData.working_name,
            hours_per_day: workingDaysData.hours_per_day,
            monday: workingDaysData.monday,
            tuesday: workingDaysData.tuesday,
            wednesday: workingDaysData.wednesday,
            thursday: workingDaysData.thursday,
            friday: workingDaysData.friday,
            saturday: workingDaysData.saturday,
            sunday: workingDaysData.sunday,
          };
          fetch(AddWorkingType, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(apiData),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then((data) => {
              if (data.response_code === "0000") {
                Swal.fire({
                  title: "Success!",
                  text: "Working days updated successfully.",
                  icon: "success",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: "swal-custom-confirm-btn",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    navigate("/leave-page/working-days");
                  }
                });
              } else {
                console.error("API error:", data);
              }
            })
            .catch((error) => {
              console.error("Error in API request:", error);
            });
        } else {
          setValidationErrors({
            ...validationErrors,
            working_name: `Working name already exists.`,
          });
        }
      })
      .catch((error) => {
        console.error("Error in WorkingNameCheck:", error);
      });
  };

  const handleCancel = () => {
    navigate("/leave-page/working-days");
  };
  function WorkingNameCheck(working_Name) {
    const OrgID = getOrgId();

    const json_Body = {
      organization_id: OrgID,
      working_name: working_Name,
    };
    return fetch(WorkingTypeNameCheck, {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify(json_Body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.response_code === "0000") {
          return true;
        } else if (data.response_code === "5000") {
          return false;
        } else {
          throw new Error("Unexpected response code");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error;
      });
  }

  return (
    <div className="">
      <span className="breadcrumb d-flex gap-2">
        <Link className="previou-link text-decoration-none" to="/leave-page">
          Leave Setting
        </Link>
        <span>/</span>
        <Link
          className="previou-link text-decoration-none"
          to="/leave-page/working-days"
        >
          Working Days
        </Link>
        <span>/</span>
        <span className="current-link text-decoration-none">
          Add Working Days
        </span>
      </span>
      <span className="title">Add Working Day</span>
      <div className="conner">
        <div className="row mt-4">
          <div className="col-md-6 mt-1">
            <div
              className="edit-card border rounded"
              style={{ justifyContent: "space-between", padding: "16px" }}
            >
              <div className="input-group">
                <div className="form-group col-md-12">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter working day name"
                    required
                    onChange={(e) => {
                      setWorkingDaysData({
                        ...workingDaysData,
                        working_name: e.target.value,
                      });
                      setValidationErrors({
                        ...validationErrors,
                        working_name: "",
                      });
                      WorkingNameCheck(e.target.value);
                    }}
                  />
                  {validationErrors.working_name && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {validationErrors.working_name}
                    </p>
                  )}
                </div>
              </div>
              <div className="input-group">
                <div className="form-group col-md-12">
                  <label>Hours Per Day</label>
                  <input
                    type="number"
                    className="form-control no-arrows"
                    placeholder="Enter hours per day"
                    required
                    min="1"
                    max="24"
                    onChange={(e) => {
                      let value = parseInt(e.target.value, 10);

                      if (isNaN(value) || value <= 0) {
                        value = 1;
                        e.target.value = 1;
                      } else if (value > 24) {
                        value = 24;
                        e.target.value = 24;
                      }
                      setWorkingDaysData({
                        ...workingDaysData,
                        hours_per_day: value,
                      });
                      setValidationErrors({
                        ...validationErrors,
                        hours_per_day: "",
                      });
                    }}
                  />
                  {validationErrors.hours_per_day && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {validationErrors.hours_per_day}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mt-1">
            <div className="card">
              <div className="card-body">
                <span className="title">Working Days</span>
                <table className="table">
                  <thead>
                    <tr>
                      <th className="heading-table">Days</th>
                      <th className="heading-table">Select</th>
                    </tr>
                  </thead>
                  <tbody>
                    {daysOfWeek.map((day) => (
                      <tr key={day}>
                        <td className="body-table">{day}</td>
                        <td className="body-table">
                          <input
                            className="check-box"
                            type="checkbox"
                            checked={workingDaysData[day.toLowerCase()]}
                            onChange={(e) =>
                              setWorkingDaysData({
                                ...workingDaysData,
                                [day.toLowerCase()]: e.target.checked,
                              })
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="mt-3"
        style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
      >
        <button className="button" onClick={handleCancel}>
          Cancel
        </button>
        <button
          className="button-outline"
          onClick={handleAdd}
          variant="primary"
        >
          Add
        </button>
      </div>
    </div>
  );
}
